import { render, staticRenderFns } from "./contact-request-card.vue?vue&type=template&id=2ddc7054&scoped=true&"
import script from "./contact-request-card.vue?vue&type=script&lang=js&"
export * from "./contact-request-card.vue?vue&type=script&lang=js&"
import style0 from "./contact-request-card.vue?vue&type=style&index=0&id=2ddc7054&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc7054",
  null
  
)

export default component.exports